import React, { useMemo } from 'react';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';
import { SymbolFromConfigOrPortfolioLinkedStatus } from 'portfolio/components/SymbolFromConfigOrPortfolioLinkedStatus';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import { useObvTileConfigSlice } from 'widgets/obvTile/store/config/configslice';
import { ObvTileContent } from 'widgets/obvTile/components/ObvTileContent';
import ObvTileSettings, {
    ObvTileSettingsText,
} from 'widgets/obvTile/components/settings/ObvTileSettings';
import ObvTileChartHelp from 'widgets/obvTile/components/chart/ObvTileChartHelp';
import { buildObvTileData } from 'widgets/obvTile/obvTileData';
import ConfigSettingsModal from 'widgets/tiles/components/tile/ConfigSettingsModal';

import { useWidgetContext } from 'widgets/WidgetContext';
import { obvStreamedDataSelectors } from 'widgets/obvTile/store/stream/streamSlice';

const { useWidgetStreamData, useWidgetMessages } = obvStreamedDataSelectors;

export function ObvTile() {
    const { config, dispatchConfigChanged } = useObvTileConfigSlice();
    const { bucketSize, showDataFor } = config;

    const streamData = useWidgetStreamData();
    const messages = useWidgetMessages();
    const data = buildObvTileData(bucketSize, streamData, showDataFor);

    const { widgetKey } = useWidgetContext();

    useWidgetStream();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const warning = useMemo(() => <SymbolWarning />, [config]);

    return (
        <WidgetTile className="ObvTile">
            <TileToolbar
                title="OBV"
                settingsBody={<ObvTileSettings />}
                settingsHeader={ObvTileSettingsText}
                preceedingItems={<ObvTileChartHelp />}
                messages={messages}
            />

            <div className="capsule-body">
                <SymbolFromConfigOrPortfolioLinkedStatus warning={warning}>
                    <ObvTileContent data={data} capsuleKey={widgetKey} />
                </SymbolFromConfigOrPortfolioLinkedStatus>
            </div>
        </WidgetTile>
    );

    function SymbolWarning() {
        return (
            <span>
                Select a symbol or specify one in the&nbsp;
                <ConfigSettingsModal
                    dispatcher={dispatchConfigChanged}
                    triggerText={'Capsule Settings'}
                    headerText={ObvTileSettingsText}
                    renderSettings={(p) => <ObvTileSettings {...p} />}
                />
                .
            </span>
        );
    }
}
